module.exports = __webpack_public_path__ + "img/bptlbarmarkergreen.007ebc66.svg";